<template>
  <div>
    <b-row>
      <b-col
        cols="12"
        sm="6"
        md="4"
        class="d-flex justify-content-start align-items-center"
      >
        {{ $lang.tabName.replace(`{0}`, label) }}
      </b-col>
      <b-col cols="12" sm="6" md="8">
        <b-form-group class="show_data text-left" label-cols="12">
          <b-form-checkbox
            v-for="(option, i) in options"
            :key="i"
            :value="option.value"
            :disabled="option.value == selected"
            name="radio"
            @change.native="putStatus"
            v-model="selected"
            unchecked-value="false"
            class="text-left"
          >
            {{ option.text }}
          </b-form-checkbox>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  inject: [],
  props: {
    tabs_option: {
      type: Object,
      default: () => {},
    },
    value: {
      type: Boolean,
      default: null,
    },
    person_code: {
      type: [String, Number],
      default: "",
    },
    label: {
      type: String,
      default: "-",
    },
    tabName: {
      type: String,
      default: "-",
    },
  },
  data() {
    return {
      selected: this.value,
      options: [
        {
          text: this.$lang.yes,
          value: true,
        },
        {
          text: this.$lang.no,
          value: false,
        },
      ],
    };
  },
  methods: {
    async putStatus() {
      this.$emit("updateTab", this.tabs_option, this.selected);
    },
  },

  watch: {
    value(newValue) {
      this.selected = newValue;
    },
  },
};
</script>

<style>
.show_data > .form-row > .col {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
</style>
